import React, { Component } from "react";
import { Form } from "informed";
import { UncontrolledCollapse } from "reactstrap";
import { Link } from "react-router-dom";

import SegmentButton from "../../common/form-fields/segment-button/SegmentButton";
import ModalDialog from "../../common/modal-dialog/ModalDialog";
import { AppLinks } from "../../../constants/app-links";
import Util from '../../common/util/util';

import SignaturePanel from "./SignaturePanel.component";
import HighDeductiblePanel from "./HighDeductiblePanel.component";

import "./PetPolicyRate.component.css";

function truncateWithEllipsis(name, maxLength = 20) {
  if (!name) return "";
  return name.length > maxLength 
    ? name.substring(0, maxLength).replace(/\s+$/, "") + "…" 
    : name;
}

class PetPolicyRate extends Component {
    constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedPlan: this.getCurrentPlan(),

      selectedPlanType: "signature",
      selectedCoinsurance: null,
      selectedAnnualLimit: null,
      selectedDeductible: null,
      selectedCoverage: null,
      selectedPremium: null,

      selectedHighDeductibleCoinsurance: null,
      selectedHighDeductibleDeductible: null,
      selectedHighDeductibleCoverage: null,
      selectedHighDeductiblePremium: null,

      tempSelectedCoinsurance: null,
      tempSelectedDeductible: null,
      tempSelectedCoverage: null,
      tempSelectedPremium: null,
      tempSelectedPolicyLimit: null,
      tempSelectedHighDeductibleCoinsurance: null,
      tempSelectedHighDeductibleDeductible: null,
      tempSelectedHighDeductibleCoverage: null,
      tempSelectedHighDeductiblePremium: null,
      
    };

    this.policyOptionSelectorFormApi = null;
    this.tempSelectedPremium =  this.state.monthlyTotal;
    this.noMonthlyRate = false;

    this.hasSignaturePLanOptions = false;
    this.hasHighDeductiblePlanOptions = false;
  }

    componentDidMount() {
    const { policies } = this.props.policyOptions;
        let selectedPlan = policies.find(plan => plan.is_current_plan);
        if (!selectedPlan) {
            selectedPlan = policies.find(plan => plan.default_plan);
        }

    // Just pick *any* one default Signature plan (first match)
    // const defaultSignature = policies.find(plan => plan.deductible < 1500);

    //  Just pick *any* one default High Deductible plan (first match)
    // const defaultHighDeductible = policies.find(plan => plan.deductible >= 1500);

    // iterate through the policy details and set the default selectedCoinsurance, selectedDeductible, selectedCoverage, 
    // selectedHighDeductibleCoinsurance, selectedHighDeductibleDeductible, selectedHighDeductibleCoverage
    // based on the available policies
    // if 80% and $1500 is available, set it as the default high deductible plan
    // if 80% and $500 is available, set it as the default signature plan
    // if no 1500 deductible plan is available, choose the next lowest deductible plan, and choose the highest reimbursement
    let highestReimbursement = 10;
    let highestDeductible = 1000000;
    let highestPolicyLimitName = "";
    let highestPremium = 1;
    let highestHighDeductibleReimbursement = 10;
    let highestHighDeductibleDeductible = 1000000;
    let highestHighDeductiblePremium = 1;
    let defaultSignatureReimbursement = 80;
    let defaultSignatureDeductible = 500;
    let defaultSignaturePremium = 50;
    let hasDefaultSignatureCoverage = false;
    let selectedPlanType = "";

    for (let i = 0; i < policies.length; i++) {

        if (policies[i].reimbursement*100 == defaultSignatureReimbursement && policies[i].deductible == defaultSignatureDeductible) {
            hasDefaultSignatureCoverage = true;
            defaultSignaturePremium = policies[i].monthly_total_payment;
        }

            this.hasSignaturePlanOptions = true;
            if (!hasDefaultSignatureCoverage) {
                if (policies[i].reimbursement*100 > highestReimbursement) {
                    highestReimbursement = policies[i].reimbursement*100;
                    highestPremium = policies[i].monthly_total_payment;
                }
                if (policies[i].deductible < highestDeductible) {
                    highestDeductible = policies[i].deductible;
                    highestPremium = policies[i].monthly_total_payment;
                }
                highestPolicyLimitName = policies[i].annual_limit;
            }
    }   

    
    if (hasDefaultSignatureCoverage) {
        highestReimbursement = defaultSignatureReimbursement;
        highestDeductible = defaultSignatureDeductible;
        highestPremium = defaultSignaturePremium;
    }

    if (selectedPlan) {
        highestReimbursement = selectedPlan.reimbursement*100;
        highestDeductible = selectedPlan.deductible;
          highestPremium = selectedPlan.monthly_total_payment;
          highestPolicyLimitName = selectedPlan.annual_limit;
          selectedPlanType = "signature";
     
      // Update parent (ChangePolicyOptions)
      this.props.updateSelectedPlan(selectedPlan, this.props.policyOptions.pet.pet_id);
        }

    this.setState({
      selectedPlan: selectedPlan,
      selectedPlanType: selectedPlanType,
      selectedCoinsurance: highestReimbursement,
      selectedAnnualLimit: highestPolicyLimitName,
      selectedDeductible: highestDeductible,
      selectedCoverage: highestReimbursement + "_" + highestDeductible,
      selectedPremium: highestPremium,
      selectedHighDeductibleCoinsurance: highestHighDeductibleReimbursement,
      selectedHighDeductibleDeductible: highestHighDeductibleDeductible,
      selectedHighDeductibleCoverage: highestHighDeductibleReimbursement + "_" + highestHighDeductibleDeductible,
      selectedHighDeductiblePremium: highestHighDeductiblePremium,
      tempSelectedCoinsurance: highestReimbursement,
      tempSelectedDeductible: highestDeductible,
      tempSelectedCoverage: highestReimbursement + "_" + highestDeductible,
      tempSelectedPremium: highestPremium,
      tempSelectedHighDeductibleCoinsurance: highestHighDeductibleReimbursement,
      tempSelectedHighDeductibleDeductible: highestHighDeductibleDeductible,
      tempSelectedHighDeductibleCoverage: highestHighDeductibleReimbursement + "_" + highestHighDeductibleDeductible,
        tempSelectedHighDeductiblePremium: highestHighDeductiblePremium,
        tempSelectedPolicyLimit: highestPolicyLimitName,
    });
  }

    handleCoinsuranceChange = (option) => {
        const selectedCoinsurance = Number(option.currentTarget.value);
        const { tempSelectedDeductible, selectedAnnualLimit } = this.state;

        const selectedPlan = this.props.policyOptions.policies.find(plan =>
            plan.reimbursement * 100 === selectedCoinsurance &&
            plan.deductible === tempSelectedDeductible &&
            String(plan.annual_limit) === String(selectedAnnualLimit)
        );

        this.setState({
            tempSelectedCoinsurance: selectedCoinsurance,
            tempSelectedPremium: selectedPlan
                ? selectedPlan.monthly_total_payment
                : this.state.tempSelectedPremium // KEEP OLD VALUE
        });
    };

    handleDeductibleChange = (option) => {
        const selectedDeductible = Number(option.currentTarget.value);
        const { tempSelectedCoinsurance, tempSelectedPolicyLimit } = this.state;

        const selectedPlan = this.props.policyOptions.policies.find(plan =>
            plan.reimbursement * 100 === tempSelectedCoinsurance &&
            plan.deductible === selectedDeductible &&
            String(plan.annual_limit) === String(tempSelectedPolicyLimit)
        );

        this.setState({
            tempSelectedDeductible: selectedDeductible,
            tempSelectedPremium: selectedPlan
                ? selectedPlan.monthly_total_payment
                : this.state.tempSelectedPremium //KEEP OLD VALUE
        });
    };

    handlePolicyLimitChange = (option) => {
        const selectedPolicyLimit = option.currentTarget.value;
        const { tempSelectedCoinsurance, tempSelectedDeductible } = this.state;

        const selectedPlan = this.props.policyOptions.policies.find(plan =>
            plan.reimbursement * 100 == tempSelectedCoinsurance &&
            plan.deductible == tempSelectedDeductible &&
            String(plan.annual_limit) === String(selectedPolicyLimit)
        );

        this.setState({
            tempSelectedPolicyLimit: selectedPolicyLimit,
            tempSelectedPremium: selectedPlan
                ? selectedPlan.monthly_total_payment
                : this.state.tempSelectedPremium
        });
    };

  // Handle High Deductible Plan selections
  handleHighDeductibleCoinsuranceChange = (option) => {
    const selectedPlan = this.props.policyOptions.policies.find(
      plan =>
        plan.reimbursement * 100 == option.currentTarget.value &&
        plan.deductible == this.state.tempSelectedHighDeductibleDeductible
    );

    this.setState({
      tempSelectedHighDeductibleCoinsurance: option.currentTarget.value,
      tempSelectedHighDeductiblePremium: selectedPlan ? selectedPlan.monthly_total_payment : null
    });
  };

  handleHighDeductibleDeductibleChange = (option) => {
    const selectedPlan = this.props.policyOptions.policies.find(
      plan =>
        plan.reimbursement * 100 == this.state.tempSelectedHighDeductibleCoinsurance &&
        plan.deductible == option.currentTarget.value
    );

    this.setState({
      tempSelectedHighDeductibleDeductible: option.currentTarget.value,
      tempSelectedHighDeductiblePremium: selectedPlan ? selectedPlan.monthly_total_payment : null
    });
  };

  confirmSelectedPlan = (planType) => {
      let selectedPlan;
        const selectedPolicyLimit =
            this.state.tempSelectedPolicyLimit || this.state.selectedAnnualLimit;

        selectedPlan = this.props.policyOptions.policies.find(
            plan =>
                plan.reimbursement * 100 === Number(this.state.tempSelectedCoinsurance) &&
                plan.deductible === Number(this.state.tempSelectedDeductible) &&
                String(plan.annual_limit) === String(selectedPolicyLimit)
        );

      this.setState({
        selectedPlanType: "signature",
        selectedPlan,
        selectedCoinsurance: this.state.tempSelectedCoinsurance,
        selectedDeductible: this.state.tempSelectedDeductible,
        selectedCoverage: this.state.tempSelectedCoverage,
        selectedPremium: this.state.tempSelectedPremium,
        selectedAnnualLimit: selectedPlan?.annual_limit || selectedPolicyLimit,
      });

    // Update parent (ChangePolicyOptions)
    this.props.updateSelectedPlan(selectedPlan, this.props.policyOptions.pet.pet_id);
  };


  // Gets the current coverage from the available policy options.  If there is no current plan available, return null
    getCurrentPlan = () => {
    const { policies } = this.props.policyOptions || {};
    if (!policies || policies.length === 0) {
      return null; // no current plan available
    }
    return policies.find(policy => policy.is_current_plan);
  }

  toggleDialog = () => {
    this.setState(prevState => ({
      showModal: !prevState.showModal
    }));
  };

  setPolicyOptionSelectorFormApi = (api) => {
    this.policyOptionSelectorFormApi = api;
  }

    reset = () => {
    const currentPlan = this.getCurrentPlan();

    if (!currentPlan) {
      // if current plan is null, no options should be selected in either panel and monthly premium should be reset to initial value
      this.setState({
        selectedPlan: null,
        selectedPlanType: "none",
      });

    } else {

        // Reset to Signature Plan
        this.setState({
          selectedPlan: currentPlan,
          selectedPlanType: "signature",
          selectedCoinsurance: currentPlan.reimbursement * 100,
          selectedDeductible: currentPlan.deductible,
          selectedCoverage: currentPlan.reimbursement * 100 + "_" + currentPlan.deductible,
          selectedPremium: currentPlan.monthly_total_payment,
          selectedAnnualLimit: currentPlan.annual_limit,

          tempSelectedCoinsurance: currentPlan.reimbursement * 100,
          tempSelectedDeductible: currentPlan.deductible,
          tempSelectedCoverage: currentPlan.reimbursement * 100 + "_" + currentPlan.deductible,
            tempSelectedPremium: currentPlan.monthly_total_payment,
            tempSelectedPolicyLimit: currentPlan.annual_limit,
        
        });
        }

    // also notify parent about the reset
    this.props.updateSelectedPlan(currentPlan, this.props.policyOptions.pet.pet_id);
  }

  render = () => {
    const { Name, Type, Age, Breed } = this.props.pet;
    const { resetLabel } = this.props;

    return (
      <React.Fragment>
        <ModalDialog
          isOpen={this.state.showModal}
          toggle={this.toggleDialog}
          modalHeader={"Unable to display this option."}
          modalBody={
            <div className="d-flex flex-column">
              <p>
                There was a problem displaying this option. Please try again later or <Link style={{ textDecoration: "none" }} to={AppLinks.others.contact}>contact us</Link>.
              </p>
            </div>
          }
          modalFooter={
            <button
              className="button-primary-plus close-button"
              type="submit"
              onClick={this.toggleDialog}
            >
              Close
            </button>
          }
        />
        <Form>
          <div className="pet-policy-rate">
            {/*{this.policyOptionSelector(Name, this.state.selectedPlan)}*/}

            <div className="row">
              <div className="col-md-12 mb-2" style={{ paddingRight: "10px", paddingLeft: "10px" }}>
                <div className="pet-details-edit">
                  <div className="pet-details-info">
                    <h2 className="pet-details-name">
                      {truncateWithEllipsis(Name, 20)},
                    </h2>
                    <span className="pet-details-age-breed">{Age === 0 ? (Type === "Dog" ? "Puppy" : "Kitten") : "Age " + Age}, {Breed}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="pet-plan-selector">
              <div className="row d-flex gx-4">
                {this.hasSignaturePlanOptions && (
                  <div className="d-inline col-md-12">
                    <div className="px-2 align-top">
                      <SignaturePanel
                                            policyDetails={this.props.policyOptions}
                                            selectedPlan={this.state.selectedPlan}
                                            selectedPlanType={this.state.selectedPlanType}
                                            setSelectedPlanType={this.confirmSelectedPlan}
                                            handleCoinsuranceChange={this.handleCoinsuranceChange}
                                            handleDeductibleChange={this.handleDeductibleChange}
                                            handlePolicyLimitChange={ this.handlePolicyLimitChange }
                                            selectedCoinsurance={this.state.selectedCoinsurance}
                                            selectedAnnualLimit={this.state.selectedAnnualLimit}
                                            selectedDeductible={this.state.selectedDeductible}
                                            selectedCoverage={this.state.selectedCoverage}
                                            selectedPremium={this.state.selectedPremium}
                                            tempSelectedCoinsurance={this.state.tempSelectedCoinsurance}
                                            tempSelectedDeductible={this.state.tempSelectedDeductible}
                                            tempSelectedCoverage={this.state.tempSelectedCoverage}
                                            tempSelectedPremium={this.state.tempSelectedPremium}
                                            tempSelectedPolicyLimit={this.state.tempSelectedPolicyLimit }
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="d-block mt-3 reset-link" onClick={this.reset}>
                {resetLabel}
              </div>              
            </div>

          </div>
        </Form>
      </React.Fragment>
    );
  };
}

export default PetPolicyRate;
